module.exports = __webpack_public_path__ + "static/media/certified.644dd5a2.svg";